(function() {
  'use strict';

  /**
   * Announcement bar component wrapper.
   * All logic is kept exactly the same, only wrapped in a component-style
   * function and with a more specific height update function name.
   */
  function AnnouncementBarComponent() {
    // Store the time (timestamp) when the bar was closed.
    // We will keep this in sessionStorage so that a completely new browser/tab
    // session will see the bar again, but within the same session it can stay
    // hidden for a configurable time.
    var KEY = 'announcement-bar-closed-at';
    var timer;
    var resizeTimer;

    function getBar() {
      return document.querySelector('.announcement-bar-section');
    }
  
    function updateAnnouncementBarHeight() {
      var bar = getBar();
      if (!bar) return;
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        bar.classList.contains('announcement-bar-hidden') ? '0px' : bar.offsetHeight + 'px'
      );
    }
  
    function getReopenDelayMinutes(bar) {
      if (!bar) return null;
      var attr = bar.getAttribute('data-reopen-delay-minutes');
      if (!attr) return null;
      var minutes = parseInt(attr, 10);
      if (isNaN(minutes) || minutes < 0) return null;
      return minutes;
    }
  
    function closeBar() {
      var bar = getBar();
      if (!bar) return;
      
      // Add hidden class
      bar.classList.add('announcement-bar-hidden');
      
      // Save close time to sessionStorage (per tab/browser session)
      try { 
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem(KEY, String(Date.now()));
        }
      } catch(e) {
        console.warn('Could not save announcement close time:', e);
      }
      
      // Update height
      updateAnnouncementBarHeight();
      
      // Trigger custom event for other scripts
      try {
        var event = new CustomEvent('announcement-bar-closed');
        document.dispatchEvent(event);
      } catch(e) {
        console.warn('Could not dispatch event:', e);
      }
      
      return false; // Prevent default behavior
    }
  
    // Expose function globally IMMEDIATELY (before DOM ready)
    // This ensures onclick="closeAnnouncementBar()" works
    window.closeAnnouncementBar = closeBar;
  
    function init() {
      var bar = getBar();
      if (!bar) {
        // Retry if bar not found yet
        setTimeout(init, 100);
        return;
      }
      
      // Check if already closed from sessionStorage and if the configured time
      // has passed. If time has passed, we show it again and clear the key.
      try {
        if (typeof sessionStorage !== 'undefined') {
          var stored = sessionStorage.getItem(KEY);
          if (stored) {
            var closedAt = parseInt(stored, 10);
            var now = Date.now();
            var reopenDelayMinutes = getReopenDelayMinutes(bar);
            var shouldStillBeHidden = false;
            
            if (!isNaN(closedAt) && reopenDelayMinutes !== null && reopenDelayMinutes > 0) {
              var diffMs = now - closedAt;
              var delayMs = reopenDelayMinutes * 60 * 1000;
              shouldStillBeHidden = diffMs < delayMs;
            }
            
            if (shouldStillBeHidden) {
              // Time hasn't passed yet - keep it hidden
              bar.classList.add('announcement-bar-hidden');
              updateAnnouncementBarHeight();
            } else {
              // Either invalid timestamp, delay is 0, or time has passed:
              // remove hidden class to show the bar again, and clear the key
              bar.classList.remove('announcement-bar-hidden');
              sessionStorage.removeItem(KEY);
              updateAnnouncementBarHeight();
            }
          } else {
            // No stored value - make sure bar is visible (remove hidden class if present)
            bar.classList.remove('announcement-bar-hidden');
          }
        } else {
          // sessionStorage not available - make sure bar is visible
          bar.classList.remove('announcement-bar-hidden');
        }
      } catch(e) {
        console.warn('Error reading announcement close time:', e);
        // On error, make sure bar is visible
        bar.classList.remove('announcement-bar-hidden');
      }
      
      // Initial height update
      updateAnnouncementBarHeight();
      
      // Click handler with event delegation - handles both onclick and direct clicks
      document.addEventListener('click', function(e) {
        // Check if clicked element or its parent has the close class
        var closeButton = e.target.closest('.AnnouncementBar__Close');
        if (closeButton) {
          e.preventDefault();
          e.stopPropagation();
          closeBar();
          return false;
        }
      }, true); // Use capture phase for better reliability
    }
  
    // Initialize immediately and also on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      // DOM already loaded - initialize immediately
      init();
    }
  
    // Also try to initialize after a short delay to catch late-loading elements
    setTimeout(init, 500);
  
    // Handle resize - reinitialize slider and update heights
    window.addEventListener('resize', function() {
      clearTimeout(timer);
      clearTimeout(resizeTimer);
      
      // Update height immediately
      updateAnnouncementBarHeight();
      
      // Reinitialize slick slider on resize (debounced)
      resizeTimer = setTimeout(function() {
        // Reinitialize slick slider if jQuery and slick are available
        if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
          // Find all announcement sliders
          var $sliders = jQuery('.announcement-slider');
          $sliders.each(function() {
            var $slider = jQuery(this);
            if ($slider.hasClass('slick-initialized') && $slider.children().length > 1) {
              // Refresh slick on resize
              $slider.slick('setPosition');
            }
          });
        }
        
        // Update height after slider refresh
        updateAnnouncementBarHeight();
      }, 150);
    }, { passive: true });
  }

  // Create component instance (logic runs immediately inside)
  AnnouncementBarComponent();
})();
